export default __webpack_public_path__ + "assets/images/aistudio/51c04140e24898c5346c6995b4548540.png";